/** In-app path (keeps overview shell + side nav). */
export const DEV_TOOLS_PATH = '/app/overview/dev/tools';

export const isDevToolsEnabled = (isSpecialAdmin) => Boolean(isSpecialAdmin);
